import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../shared/services/common.service';
import { MessageService } from '../../../shared/services/message.service';
import { DocumentLibrary, DocumentLibraryRequest } from '../../interface/enrollment/document-library.interface';
import { EnrollService } from '../../services/enrollment.service';

@Component({
    selector: 'app-documents',
    templateUrl: '../../templates/template1/views/enrollment/documents.component.html',
    styleUrls: ['../../templates/template1/themes/default/css/documents.component.less']
})
export class DocumentsComponent implements OnInit {
    @Input() documentRequest: DocumentLibraryRequest;
    @Input() privacyCheckBox : boolean;
    @Output() getDocuments = new EventEmitter<any>();
    @Input() agreementDocuments: DocumentLibrary[];
    privacyPreference: boolean = true;
    privacyPreferenceSubscription: Subscription;
    constructor(
        private _enrollService: EnrollService,
        private _commonService: CommonService,
        private _messageService: MessageService
    ) { }

    ngOnInit(): void {
        if (!this.agreementDocuments || !this.agreementDocuments.length && this.documentRequest) {
            this.fetchTermsConditionDocument();
        }
        this.getPrivacyPreference();
        this.setPrivacyPreference();

    }

    ngOnDestroy(): void {
        if(this.privacyPreferenceSubscription){
        this.privacyPreferenceSubscription.unsubscribe();
        }
    }


    /**
     * @description get Terms and Conditions Document
     * fetchTermsConditionDocument
     * @memberof OrderPromotionComponent
     */
    fetchTermsConditionDocument(): void {
        this._commonService.getDocuments(this.documentRequest.portalId, this.documentRequest.customerTypeId,
            this.documentRequest.displaySectionId, this.documentRequest.countryCode, this.documentRequest.languageCode)
            .subscribe((response) => {
                if (response && response.length > 0 && response[0].body && response[0].body.length > 0) {
                    this.agreementDocuments = response[0].body;
                    this.getDocuments.emit(this.agreementDocuments);
                }
            });
    }

    /**
   * @description
   * @date 2018-09-17
   * @memberof OrderPromotionComponent
   */
    onChangeAgreements(index: number): void {
        this.agreementDocuments[index].isSelected
            = !this.agreementDocuments[index].isSelected;
        this.getDocuments.emit(this.agreementDocuments);
    }
    
    setPrivacyPreference(event? :any){
        if(event){
            this.privacyPreference = !this.privacyPreference;
            this._enrollService.setPrivacyRequested(this.privacyPreference);
        }
        else{
            this._enrollService.setPrivacyRequested(this.privacyPreference);
        }

    }

    getPrivacyPreference() {
        this.privacyPreferenceSubscription = this._messageService.getExistingPrivacyPreference().subscribe((privacyPreference) => {
            this.privacyPreference = privacyPreference;
            this.setPrivacyPreference();
        });
    }
 

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/enrollment/documents.component.ts